import { z } from 'zod';
export const JsonObjectSchema = z.string().transform((str, ctx) => {
    try {
        return JSON.parse(str);
    }
    catch (_error) {
        ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
        return z.NEVER;
    }
});
//# sourceMappingURL=zod.js.map